import Pagination from "../class/PaginationClass";
import {SuperAlign} from "../class/SuperAlign";
const superAlign = new SuperAlign('.js-text-normalize');
superAlign.init();
$(function (){
  $(".js-entry-content").each(function(index) {
    $(this).addClass('slide-baby');
  });
})

new Pagination('.pagination', '/ajax/get_videos_by_page.php', function(results){

  $(this).css('transition-delay','').css('transition-duration','0ms').removeClass('slide-baby');


  let userLang = document.documentElement.lang;

  $(".js-entry-content").each(function(index){


    const unixTime = results[index].publish_date;
    const date = new Date(unixTime*1000);

    $(this).find('.pagination-picture').attr('data-modal-data', JSON.stringify(results[index]));

    if (userLang === 'fr') {
      $(this).find('.pagination-img').attr('src', baseUrl+results[index].video.poster_fr).attr('alt', results[index].title_fr);
    } else {
      $(this).find('.pagination-img').attr('src', baseUrl+results[index].video.poster_en).attr('alt', results[index].title_en);
    }
    $(this).find('.pagination-date').html(
      date.toLocaleString('default', { month: 'long' }) + ' ' +
      date.getDay() + 'th, ' +
      date.getFullYear());
    $(this).find('h4').html(results[index].title);
    $(this).find('p').html(results[index].description);

    var that = this;
    setTimeout(function(){
      $(that).css('transition-delay', (index + 1) * 50 + 'ms').css('transition-duration','').addClass('slide-baby');
    }, 25);
  });

}).init();



